import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AppStore } from "src/app/core/store/app.store";
import { environment } from "src/environments/environment";
import { IAppTitle } from "../../../interfaces";
import { IUser } from "../../../interfaces/user.interface";

@Component({
  selector: "siu-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  @Input() user: IUser;
  @Input() isMobile: boolean;
  @Input() title: IAppTitle;
  @Output("on-toogle-drawer") onToogleDrawerEvent: EventEmitter<any> =
    new EventEmitter<any>();
  @Output("on-logout") onLogoutEvent: EventEmitter<any> =
    new EventEmitter<any>();
  @Output("on-click-logo") onClickLogoEvent: EventEmitter<any> =
    new EventEmitter<any>();
  @Input() showToogleButton: boolean = false;
  @Output("on-click-change-password")
  onClickChangePasswordEvent: EventEmitter<any> = new EventEmitter<any>();
  constructor(private router: Router, private appStore: AppStore) {}

  tipoUser: boolean = false;

  ngOnInit() {

  }

  handleToogleDrawer = () => {
    this.onToogleDrawerEvent.emit();
  };

  handleLogout = () => {
    console.log('headerLogout');
    localStorage.setItem('avisoAceptado', '0');
    let tipo = this.user.ttipoUsuario
    this.appStore.sessionAction.logout();

    if(tipo == 1){
      location.href = environment.loginOut + location.origin + this.router.routerState.snapshot.url;
    }
    else{
      location.href = environment.loginOutSIGO + location.origin + this.router.routerState.snapshot.url;
    }

    this.onLogoutEvent.emit();
  };

  handleClickLogo = () => {
    this.onClickLogoEvent.emit();
  };

  handleClickChangePassword = () => {
    this.onClickChangePasswordEvent.emit();
    this.router.navigate(["/clave/"]);
  };

  handleNoButton = (event) => {
    event.stopPropagation();
  }
}
